/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

import {I18nAdapter} from '@/services/language/adapter/I18nAdapter';
import {MomentAdapter} from '@/services/language/adapter/MomentAdapter';
import {VeeValidateAdapter} from '@/services/language/adapter/VeeValidateAdapter';
import {PersistenceAdapter} from '@/services/language/adapter/PersistenceAdapter';

/**
 * Adapter module.
 *
 * @author Jonny Cook
 */
export {I18nAdapter, PersistenceAdapter, MomentAdapter, VeeValidateAdapter};
